export default __webpack_public_path__ + "static/media/7.98117268.svg";